import SongwriterWriterSearchStore, {
    songwriterLinkSearchOptions,
} from '@App/stores/search/songwriter/songwriter-writer-search-store'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { WriterSearch } from '@App/stores/search/models/writer-search'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import RootStore from '@App/stores/root-store'
import { SongwriterWriterSearch } from '@App/stores/search/models/songwriter-writer-search'
import { generateSearchCriterionFromOption } from '@App/helpers/generate-search-criterion'

export const defaultSongwriterMyWriterCriteria: Array<SearchCriterion<WriterSearch>> = [
    generateSearchCriterionFromOption(songwriterLinkSearchOptions[0], true, true, undefined),
    generateSearchCriterionFromOption(songwriterLinkSearchOptions[1], true, true, undefined),
]

export default class SongwriterMyWriterSearchStore extends SongwriterWriterSearchStore {
    readonly canAddCriteria: boolean = false
    public searchFilters = []

    constructor(rootStore: RootStore) {
        super(rootStore)
        super.setSearchFilters({ inCatalogFilter: 'onlyWritersInCatalog' })
    }

    createWriterSearchCriteriaStore(): SearchCriteriaStore<WriterSearch> {
        return new SearchCriteriaStore(
            defaultSongwriterMyWriterCriteria,
            songwriterLinkSearchOptions,
            SearchOptionType.primary,
            RequiredCriteria.some,
            2
        )
    }

    resetSearchCriteriaStore(): void {
        this._currentSearchCriteriaStore = this.createWriterSearchCriteriaStore()
    }

    public setCurrentSearchFilters(filters: Partial<SongwriterWriterSearch>) {
        super.setSearchFilters(filters)
    }

    resetStore(): void {
        super.resetStore()
        super.setSearchFilters({ inCatalogFilter: 'onlyWritersInCatalog' })
    }
}
